import React, { useEffect, useRef } from 'react';
import { LeafIcon } from 'lucide-react';
import Hls from 'hls.js';
export function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const videoSrc = 'https://vz-59c3ae15-de5.b-cdn.net/69dd5a0f-e260-44cf-8087-16004be6a26d/playlist.m3u8';
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(video);
      return () => hls.destroy();
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // Safari native HLS support
      video.src = videoSrc;
    }
  }, []);
  return <header className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden border-b border-white/5" data-id="element-99">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.05)_0%,rgba(10,10,10,1)_100%)] pointer-events-none" data-id="element-100"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-101">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-102">
          {/* Left Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-103">
            <div className="inline-flex items-center px-4 py-1 border border-brand-gold/30 rounded-full text-brand-gold text-xs font-bold tracking-widest uppercase mb-6" data-id="element-104">
              <LeafIcon className="w-3 h-3 mr-2" data-id="element-105" />
              Descubrimiento Orgánico
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 glow-text" data-id="element-106">
              Tu cocina tiene <span className="text-brand-gold" data-id="element-107">la cura</span>{' '}
              que las farmacias no quieren que descubras.
            </h1>

            <p className="text-lg md:text-xl text-gray-400 mb-8 font-light leading-relaxed" data-id="element-108">
              El Secreto Ancestral de 14 Días para Detener la Caída y Activar el
              Crecimiento Folicular, sin químicos dependientes ni efectos
              secundarios.
            </p>
          </div>

          {/* Right: Video */}
          <div className="lg:w-1/2 relative group" data-id="element-109">
            <div className="absolute -inset-4 bg-brand-gold/20 blur-2xl rounded-full opacity-50 group-hover:opacity-70 transition duration-1000 z-0" data-id="element-110"></div>

            {/* Video player */}
            <div className="relative z-10 rounded-lg overflow-hidden border border-white/10 shadow-2xl" data-id="element-111">
              <video ref={videoRef} controls playsInline className="w-full h-auto" style={{
              display: 'block'
            }} data-id="element-112" />
            </div>
          </div>
        </div>
      </div>
    </header>;
}